import { ApolloQueryResult } from '@apollo/client';

import { RRealmConfigQuery, useGetRealmsQueryRemote, useRealmConfigQueryRemote } from '@/store/v2';

export interface RealmConfig {
  heroImageUrl?: string;
  heroVideoUrl?: string;
}

export interface Realm {
  realm: string;
  name: string;
}

export const useRealms = (
  skip = false,
): {
  realms: Realm[];
  loading: boolean;
} => {
  const { data, loading } = useGetRealmsQueryRemote({ skip });

  const realms: Realm[] = data?.realms ?? [];

  return {
    realms,
    loading,
  };
};

export const useRealmConfig = (
  realm: string = window.realm,
): {
  realmConfig?: RealmConfig;
  loading: boolean;
  refetch: (params?: { realm: string }) => Promise<ApolloQueryResult<RRealmConfigQuery>>;
} => {
  const { data, loading, refetch } = useRealmConfigQueryRemote({ variables: { realm } });

  const realmConfig: RealmConfig | undefined = data?.realmConfig;

  return {
    realmConfig,
    loading,
    refetch,
  };
};
